import React, { useState, useEffect } from 'react'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col, Label, Input, Button, InputGroup, InputGroupText } from 'reactstrap'
import { NavLink, useNavigate } from 'react-router-dom'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { directUrl, homePageUrl } from '../../../helpers/Constants';
import { requestApi } from '../../../request-api';


function ApproverSettings() {
    let [calendarValue, setCalenderValue] = useState(new Date());
    let [showCalender, setShowCalender] = useState(false)
    let [selectedDate, setSelectedDate] = useState("")
    let [userId, setUserId] = useState("")
    let [email, setEmail] = useState("")
    let [name, setName] = useState("")
    let [phoneNumber, setPhoneNumber] = useState("")
    let navigate = useNavigate()
    const [startDate, setStartDate] = useState(new Date());

    useEffect(() => {
        setSelectedDate(`${calendarValue.getDate()}/${calendarValue.getMonth() + 1}/${calendarValue.getFullYear()}`)
    }, [calendarValue])

    useEffect(() => {

        auditorData()

    }, [])


    const auditorData = () => {
        return requestApi('/auditor', {
            method: 'get'
        }).then((data) => {
            console.log(data)
            setUserId(data.data.id)
            setEmail(data.data.email)
            setPhoneNumber(data.data.phone_number)
            setName(data.data.name)
        })
    }

    const submitForm = (e) => {
        requestApi('/auditor/edit', {
            method: 'put',
            body: JSON.stringify({
                name: name,
                phone_number: phoneNumber,
                email: email
            })
        }).then((data) => {
            if (data.statusCode === 200) {
                navigate(`${directUrl}auditor/dashboard`)
            }
        })
    }

    return (
        <section className='lyt-section'>
            <Container fluid className='typ-container'>
                <Breadcrumb className='bs-breadcrumb mt-0'>
                    
                    <BreadcrumbItem active>Edit Profile</BreadcrumbItem>
                </Breadcrumb>
                <div className='bs-card px-0'>
                    <div className='padding-area'>
                        <form className="bs-form">
                            <Row>
                                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                    <div className='form-box'>
                                        <Label for="doj" className="mr-sm-2 cstm-label">User Name</Label>
                                        <Input type="text" name="name" id="exampleEmail" value={userId} disabled className='cstm-input' placeholder="Enter Company Id" />
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                    <div className='form-box'>
                                        <Label for="doj" className="mr-sm-2 cstm-label">Name</Label>
                                        <Input type="text" name="name" id="exampleEmail" value={name} onChange={(e) => { setName(e.target.value); }} className='cstm-input' placeholder="Enter Name" />
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                    <div className='form-box'>
                                        <Label for="doj" className="mr-sm-2 cstm-label">Change Email ID</Label>
                                        <Input type="text" name="name" id="exampleEmail" value={email} onChange={(e) => { setEmail(e.target.value); }} className='cstm-input' placeholder="Enter Email ID" />
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                    <div className='form-box'>
                                        <Label for="doj" className="mr-sm-2 cstm-label">Change Contact Number</Label>
                                        <Input type="text" name="name" id="exampleEmail" value={phoneNumber} onChange={(e) => { setPhoneNumber(e.target.value); }} className='cstm-input' placeholder="Enter Contact Number" />
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                    <button className='bs-btn btn-submit' onClick={submitForm} type='button'>SUBMIT</button>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </div>
            </Container>
        </section >
    )
}

export default ApproverSettings
